import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { BrandIconDiscord } from './brand-icon-discord';
import { BrandIconFacebook } from './brand-icon-facebook';
import { BrandIconInstagram } from './brand-icon-instagram';
import { BrandIconTelegram } from './brand-icon-telegram';
import { BrandIconX } from './brand-icon-x';
const sizes = {
    l: 48,
    m: 40,
    s: 32,
    xs: 24,
    xxs: 16,
};
export const BrandIcon = ({ size = 'l', brand, ref, ...props }) => {
    const BrandIconComponent = {
        telegram: BrandIconTelegram,
        instagram: BrandIconInstagram,
        facebook: BrandIconFacebook,
        x: BrandIconX,
        discord: BrandIconDiscord,
    }[brand];
    return (_jsx(Root, { ref: ref, ...props, children: _jsx(BrandIconComponent, { width: sizes[size], height: sizes[size] }) }));
};
const Root = styled.div `
  display: inline-flex;
`;
//# sourceMappingURL=brand-icon.js.map